import { combineReducers } from '@reduxjs/toolkit';
import status from './statusSlice';

const sharedReducers = combineReducers({
	status,
});

export default sharedReducers;
